
import $ from 'jquery';


export const whenReady = new Promise( resolve => {
	$( document ).ready( () => resolve() );
} );

export function getMetaCurrency() {
	return $( "meta[name=_currency]" )[0].content;
};

export function getMetaContent( metaname = "" )  {
	var element = document.querySelector( 'meta[name="' + metaname + '"]' );
	if ( element && element.content ) {
		return element.content;
	}
	return '';
}

export function getStyle() {
	return document.documentElement.classList.contains( 'style_gigasport' ) ? 'giga' : 'koe';
}

export function getViewControllerName() {
	return window.v_cl;
}

export function getSessionToken() {
	return window._stoken || $( 'input[name="stoken"]' ).filter( function() { return $( this ).val().length > 0 } ).first().val();
}

export function getActiveShopCountry() {
	return window.v_country;
}

export function isRetinaScreen() {
	return window.matchMedia && window.matchMedia( "(-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi)" ).matches;
}

export function getNumberFormat( variant = 1 ) {

	if ( 1 === parseInt( variant ) ) {
		return window.number_format_1 || $( "meta[name=number_format_1]" )[0].content;
	}

	if ( 2 === parseInt( variant ) ) {
		return window.number_format_2 || $( "meta[name=number_format_2]" )[0].content;
	}

	console.error( 'Invalid Number Format Variant Selected: ', variant );
	return '';
}

export function replaceGerUmlaut( value ) {
	//value = value.toLowerCase();
	value = value.replace( /\u00e4/g, 'ae' );
	value = value.replace( /\u00f6/g, 'oe' );
	value = value.replace( /\u00fc/g, 'ue' );
	value = value.replace( /\u00df/g, 'ss' );

	value = value.replace( /\u00c4/g, 'Ae' );
	value = value.replace( /\u00d6/g, 'Oe' );
	value = value.replace( /\u00dc/g, 'Ue' );
	return value;
}


export function setCookie( cname, cvalue, exdays ) {
	var d = new Date();
	d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
};

export function GetURLParameter( sParam ) {
	var sPageURL = window.location.search.substring( 1 );
	var sURLVariables = sPageURL.split( '&' );
	for ( var i = 0; i < sURLVariables.length; i++ ) {
		var sParameterName = sURLVariables[i].split( '=' );
		if ( sParameterName[0] == sParam ) {
			return sParameterName[1];
		}
	}
};

export function getParameterByName( name, url ) {
	if ( typeof url === 'undefined' ) url = window.location.href;
	name = name.replace( /[\[\]]/g, "\\$&" ); // eslint-disable-line no-useless-escape
	var regex = new RegExp( "[?&]" + name + "(=([^&#]*)|&|#|$)" ),
		results = regex.exec( url );
	if ( !results ) return null;
	if ( !results[2] ) return '';
	return decodeURIComponent( results[2].replace( /\+/g, " " ) );
};

export function toUrlParameterString( data ) {
	return Object.keys( data ).map( function( key ) {
		return encodeURIComponent( key ) + '=' + encodeURIComponent( data[ key ] )
	} ).join( '&' )
}


export function showErrorNotif( msg, id ) {
	if ( 'Toaster' in window.TAO_KOE ) {
		return window.TAO_KOE.Toaster.toast( msg, 'error' );
	}

	var err = $( '<div/>' );
	if ( id ) {
		$( '.site_inner' ).find( "#" + id ).remove();
		err.attr( 'id', id );
	}
	err.empty()
		.addClass( 'notification' )
		.addClass( 'error' )
		.append( '<p>' + msg + '</p>' )
		.append( '<i class="icon icon_close notification_close"></i>' );

	$( '.site_inner .mdl.mdl_section_header' ).after( err );

	$( 'html, body' ).animate( {
		scrollTop: 0
	}, 500 );
}

export function showCheckoutBasketErrorNotif( msg, id ) {
	var err = $( '<div/>' );
	if ( id ) {
		$( '.site_inner' ).find( "#" + id ).remove();
		err.attr( 'id', id );
	} else {
		id = 'basketerror-notif';
	}

	err.empty()
		.addClass( 'notification' )
		.addClass( 'en_spacer_top_small' )
		.attr( 'id', id )
		.append( '<p>' + msg + '</p>' )
		.append( '<i class="icon icon_close notification_close"></i>' );

	$( '.site_inner' ).before( err );

	$( 'html, body' ).animate( {
		scrollTop: 0
	}, 500 );
}

export function preventNumberInput( e ){
	var keyCode = ( e.keyCode ? e.keyCode : e.which );
	if ( keyCode > 47 && keyCode < 58 || keyCode > 95 && keyCode < 107 ){
		e.preventDefault();
	}
};

export function parseStringPriceToFloat( price, locale ) {
	function decodeHtmlEntities( str ) {
		const txt = document.createElement( 'textarea' );
		txt.innerHTML = str;
		return txt.value;
	}

	const decodedPrice = decodeHtmlEntities( price );
	const countryCode = locale.split( '-' )[1];

	//TODO CHANGE IT TO METADATA
	const separators = {
		'DE': { thousand: '.', decimal: ',' },
		'AT': { thousand: '.', decimal: ',' },
		'CH': { thousand: "'", decimal: '.' },
	};

	const { thousand, decimal } = separators[countryCode] || { thousand: ',', decimal: '.' };
	const priceWithoutThousandSeparator = decodedPrice.split( thousand ).join( '' );
	const priceWithDotAsDecimal = priceWithoutThousandSeparator.split( decimal ).join( '.' );

	return parseFloat( priceWithDotAsDecimal );
}



export function formatMoney( amount ) {
	try {

		const metaCurrency = window.metaCurrency || getMetaCurrency();

		var decimalCount = 2, decimal = ",", thousands = ".";
		amount = amount.replace( ',', '.' ).replace( metaCurrency, '' );
		decimalCount = Math.abs( decimalCount );
		decimalCount = isNaN( decimalCount ) ? 2 : decimalCount;

		const negativeSign = amount < 0 ? "-" : "";

		var i = parseInt( amount = Math.abs( Number( amount ) || 0 ).toFixed( decimalCount ) ).toString();
		var j = ( i.length > 3 ) ? i.length % 3 : 0;

		return negativeSign + ( j ? i.substr( 0, j ) + thousands : '' ) + i.substr( j ).replace( /(\d{3})(?=\d)/g, "$1" + thousands ) + ( decimalCount ? decimal + Math.abs( amount - i ).toFixed( decimalCount ).slice( 2 ) : "" );
	} catch ( e ) {
		console.log( e )
	}
};

export function __hashCode( str ) {
	return Array.from( str )
		.reduce( function( s, c ) {
			return Math.imul( 31, s ) + c.charCodeAt( 0 ) | 0
		}, 0 )
};


const stringReplaceAll = ( retStr, obj ) => {
	for ( let x in obj ) {
		retStr = retStr.replace( new RegExp( x, 'g' ), obj[x] );
	}
	return retStr;
}

/**
 * This function is here to make sure any special character such as: (™ ® © ℠ ' ') are properly url encoded
 * when filters are applied in the sidebar
 * @param newUrl
 * @return {*}
 */
export function cleanUrl( newUrl ) {

	return stringReplaceAll( newUrl, {
		'™' : '%E2%84%A2',
		'®' : '%C2%AE',
		'©' : '%C2%A9',
		'℠' : '%E2%84%A0',
		' ' : '+'
	} );
}

export function calculateDistance( uLat, uLng, sLat, sLng ){
	var Radius = 6371;
	var distanceLat = toRad( sLat - uLat );
	var distanceLng = toRad( sLng - uLng );
	var userLat = toRad( uLat );
	var shopLat = toRad( sLat );

	var a =
      Math.sin( distanceLat / 2 ) * Math.sin( distanceLat / 2 ) +
      Math.sin( distanceLng / 2 ) *
        Math.sin( distanceLng / 2 ) *
        Math.cos( userLat ) *
        Math.cos( shopLat );
	var c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
	var d = Radius * c;

	return d;
}

export function toRad( value ){
	return ( value * Math.PI ) / 180;
}

export function delay( time = 100 ) {
	return new Promise( resolve => setTimeout( resolve, time  ) );
}

export function stringToHTML( str = '' ) {
	var parser = new DOMParser();
	try {
		var doc = parser.parseFromString( str, 'text/html' );
		return doc.body.firstElementChild;
	} catch( err ) {
		var dom = document.createElement( 'div' );
		dom.innerHTML = str;
		return dom.firstElementChild;
	}
}


global.metaCurrency = getMetaCurrency();
global.number_format_1 = getNumberFormat( 1 );
global.number_format_2 = getNumberFormat( 2 );
global.getParameterByName = getParameterByName;
global.showErrorNotif = showErrorNotif;
global.showCheckoutBasketErrorNotif = showCheckoutBasketErrorNotif;
global.preventNumberInput = preventNumberInput;
global.__hashCode = __hashCode;
global.cleanUrl = cleanUrl;
